/** @module components/callouts/save-for-later-callout */
import analytics from "web/script/analytics/analytics";
import baustein from "baustein";
import traversal from "web/script/dom/traversal";
import rothko from "web/script/modules/rothko";
import template from "templates/modules/callouts/save_for_later_callout";

/**
 * Save-for-later callout module that renders a callout.
 *
 * @constructor
 * @alias module:components/callouts/save-for-later-callout
 * @extends module:baustein
 */
export default baustein.register(
    "save-for-later-callout",
    /** @lends module:components/callouts/save-for-later-callout.prototype */
    {
        template: template,

        defaultOptions: {
            next: "/",
        },

        setupEvents(add) {
            add("click", ".save-for-later-callout__button", this._onClick);
        },

        getInitialRenderContext() {
            return {
                save_for_later_callout: {},
            };
        },

        onInsert() {
            this.emit("savedForLaterOpen");
            const next = this.options.next;
            analytics.event("save_for_later_callout", "prompt_show", "save_for_later_callout");
            rothko.fetch("modules/callouts/save_for_later_callout", { next }).then((data) => {
                this.setRenderContext({
                    save_for_later_callout: data,
                    is_button: true,
                });
            });

            this.setGlobalHandler("click", this._onGlobalClick);
        },

        destroy() {
            this.emit("savedForLaterClosed");
            baustein.Component.prototype.destroy.apply(this, arguments);
        },

        _onClick(event) {
            event.preventDefault();
            this.destroy();
        },

        _onGlobalClick(event) {
            if (traversal.contains(this.el, event.target)) {
                return;
            }

            this.destroy();
        },
    }
);
